define('features/smartpath',['jquery', 'bat'], function ($, bat) {
  /*
    NOTE: this page has no associated XSL. the mark up is in the htmlcode component:
    templatedata/BAT/HTMLCode/data/smartpath_content.xml

    <script type="text/javascript">
      require(['features/smartpath'], function(smartpath) {
        smartpath.init();
      }, function(err) {
        console.log('FAILED TO LOAD SMARTPATH!!!', err);
      });
    </script>
  */
  var smartpath = {
    /*
      DATA VALUES FOR EVENTS;
      window.YT.PlayerState:
      BUFFERING:3
      CUED:5
      ENDED:0
      PAUSED:2
      PLAYING:1
      UNSTARTED:-1
    */
    startVideo: function () {
      var self = this;
      self.smartpathPlayer.playVideo();
    },

    init: function () {
      var self = this;
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      self.smartpathPlayer;
      self.videoTitle = '820 TOYOTA HOWTO V044 171006 MIX01';// TODO: THIS SHOULD BE RETRIEVED VIA youtube API. SEE BELOW.
      self.videoId = 'lqZy0ZFaawo';

      self.updateDataLayerWithTime = function (text) {
        var current = self.smartpathPlayer.getCurrentTime().toFixed(2);
        var duration = self.smartpathPlayer.getDuration().toFixed(2);
        /*
          DATA LAYER NEEDS TO BE UPDATED WIHT VIDEO TITLE , VIDEO DURATION.
          WE ONLY KONW THESE ONCE THE PLAYER HAS LOADED THE VIDEO.
          WE CAN THEN FIRE OFF THE EVENT.
        */

        if (text === 'video-start') {
          var dlStr = '{"link_text":"video-start" "video_event_title":"' + self.videoTitle + '"" "video_event_duration":"' + duration + '" "video_event_playhead":"' + current + '" }' ;
          $('.js-videoPoster').attr('data-layer', dlStr);
        }

        var dataToAdd = {
          'fireTagShortPhrase': 'aa-link',
          'video_event_title': self.videoTitle,
          'link_text': text,
          'video_event_duration': duration,
          'video_event_playhead': current,
        };
        $.extend(window.dataLayerBAT.data, dataToAdd);

        if (text === 'video-end') {
          // THIS NEEDS TO BE MANUALLY FIRED BECAUSE THE VIDEO EVENT IS SENDING THIS.
          window.dataLayerBAT.utils.triggerEvent(document, 'DL.CLICK');
        }
      };

      window.onPlayerStateChange = function (event) {
        if (event.data == window.YT.PlayerState.PLAYING) {
          self.updateDataLayerWithTime('video-start');
        }
        if (event.data == window.YT.PlayerState.ENDED) {
          $('.js-videoPoster').show();
          self.updateDataLayerWithTime('video-end');
        }
      };

      window.onYouTubeIframeAPIReady = function () {
        self.smartpathPlayer = new YT.Player('player', {
          autoplay: 0,
          videoId: self.videoId,
          events: {
            onReady: function () {
              self.onPlayerReady();
              self.smartpathPlayer.addEventListener('onStateChange', function () {});
            },
            onStateChange: function (data) {
              try {
                window.onPlayerStateChange(data);
              } catch (error) {
                console.error('STATE CHANGE ERROR', error);
              }
            }

          }
        });
      };

      // POSTER BUTTON.
      $('.js-videoPoster').on('click', function (ev) {
        $(this).hide();
        self.startVideo();
      });

      $(window).on('loaded', function () {
        bat.util.loader.hideLoader();
      });
    }
  };

  return smartpath;
});

